import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography
} from '@mui/material'
import React, { useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import { AWSMonitorSuccessEvaluation } from 'components/status-checks/form/status-check/aws/AWSMonitorSuccessEvaluation'
import { AWSMonitorURL } from 'components/status-checks/form/status-check/aws/AWSMonitorURL'
import {
  StatusCheckFormValues,
  StatusCheckMonitorSelectionRadioValue
} from 'components/status-checks/status-checks-form-utils'
import { useTranslation } from 'hooks/use-translation'

export const AWSMonitorSelection: React.FC = () => {
  const { trans } = useTranslation()
  const { control, formState } = useFormContext<StatusCheckFormValues>()

  const [radioValue, setRadioValue] =
    useState<StatusCheckMonitorSelectionRadioValue>(
      StatusCheckMonitorSelectionRadioValue.URL
    )

  return (
    <Stack sx={{ rowGap: 4 }}>
      <FormControl component={Stack} sx={{ rowGap: 2 }}>
        <Typography>
          {trans(
            'forms.save_status_check.connect_monitor.status_check_name.prompt'
          )}
        </Typography>
        <Controller
          control={control}
          name="statusCheckName"
          render={({ field }) => (
            <TextField
              {...field}
              data-testid="status-check-monitor-name-input"
              error={Boolean(formState.errors.statusCheckName)}
              helperText={formState.errors.statusCheckName?.message}
              label={trans(
                'forms.save_status_check.connect_monitor.status_check_name.text_field.label'
              )}
              variant="outlined"
            />
          )}
        />
      </FormControl>
      <RadioGroup
        data-testid="aws-monitor-selection-radio-group"
        name="monitor-selection"
        sx={{ marginLeft: 1, rowGap: 1 }}
        value={radioValue}
        onChange={(_, value: StatusCheckMonitorSelectionRadioValue) =>
          setRadioValue(value)
        }
      >
        <FormControl>
          <FormControlLabel
            control={<Radio />}
            label={trans(
              'forms.save_status_check.connect_monitor.monitor_url_aws_cloudwatch.text_field.label'
            )}
            value={StatusCheckMonitorSelectionRadioValue.URL}
          />
          <Box sx={{ marginLeft: 4 }}>
            {radioValue === StatusCheckMonitorSelectionRadioValue.URL && (
              <AWSMonitorURL
                disabled={
                  radioValue !== StatusCheckMonitorSelectionRadioValue.URL
                }
                radioValue={radioValue}
              />
            )}
          </Box>
        </FormControl>
        <FormControl>
          <FormControlLabel
            control={<Radio />}
            label={trans(
              'forms.save_status_check.connect_monitor.monitor_url_aws_api.text_field.label'
            )}
            value={StatusCheckMonitorSelectionRadioValue.API}
          />
          <Box sx={{ marginLeft: 4 }}>
            {radioValue === StatusCheckMonitorSelectionRadioValue.API && (
              <AWSMonitorSuccessEvaluation />
            )}
          </Box>
        </FormControl>
      </RadioGroup>
    </Stack>
  )
}
